<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">CROCHET ICONIC WOMEN</h1>
<h2 class="description">Amigurumi Patterns for 15 Women Who Changed the World</h2>
<h2 class="author">CARLA MITRANI</h2>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?609e1637